export default {
  steps: {
    discount: 'Rabat',
    mobile_app: 'Aplikacja mobilna',
    business_info: 'Dane firmy',
    create_preview: 'Utwórz podgląd umowy',
    preview: 'Podgląd umowy',
    sign: 'Podpisz umowę',
  },
  buttons: {
    back: 'Wstecz',
    continue: 'Kontynuuj',
  },
  agreement:
    'Przejście na plan roczny powoduje zastosowanie rabatu {{discount}}% do planu {{plan}}. Rozliczenie odbywa się miesięcznie w wysokości {{amount}} miesięcznie przez {{months}} miesięcy.',
  toasts: {
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    failed_to_switch: 'Nie udało się przełączyć na plan roczny',
    switched_to_annual: 'Umowa przełączona na plan roczny 👌',
  },
};
